import Render from '@Views/login/register.html'
import { Vue, Component } from 'vue-property-decorator'
import { login, notif } from '@Store/modules'
import { IRegister } from '@Store/types'
import config from "@Config/index"

@Render
@Component({})
export class Register extends Vue {

	last_name: string = ''
	first_name: string = ''
	code: string = ''
	confirm_email: string = ''
	cgv: boolean = false
	submitted: boolean = false
	turnstile_token: null
	refreshInterval: ReturnType<typeof setInterval> | null = null;

	//#region getters
	get email(): string {
		return login.email
	}
	set email(value: string) {
		login.updateEmail(value)
	}
	get isRegistering() {
		return login.isRegistering
	}
	get hasEmailError(): boolean {
		return this.submitted && !this.email
	}
	get hasConfirmEmailError(): boolean {
		return this.submitted && (!this.confirm_email || this.confirm_email !== this.email)
	}
	get hasLastNameError(): boolean {
		return this.submitted && !this.last_name
	}
	get hasFirstNameError(): boolean {
		return this.submitted && !this.first_name
	}
	get hasCgvError(): boolean {
		return this.submitted && !this.cgv
	}
	get hasClouFlareError(): boolean {
		return this.submitted && !this.turnstile_token
	}

	get siteKey(): string {
		return config.cloudflare_site_key
	}
	//#endregion

	canSubmit(): boolean {
		return !!this.email && !!this.confirm_email && this.email === this.confirm_email && !!this.last_name && !!this.first_name && this.cgv && this.turnstile_token
	}

	submit(event: any) {
		this.submitted = true
		if (!this.canSubmit()) return

		let register: IRegister = {
			email: this.email,
			last_name: this.last_name,
			first_name: this.first_name,
			confirm_email: this.confirm_email,
			godchild_code: this.code,
			cgv: this.cgv,
			url_connection: "https://app.osteo2ls.com/",
			turnstile_token: this.turnstile_token
		}
		login.register(register)
		.then((user: IRegister) => {
			notif.success(this.$i18n.t('vm.login.register.register.success', {email: user.email}).toString())
			this.resetTurnstile()
			this.$router.push({ name: 'authentication' })
		})
		.catch(error => {
			notif.error(error)
			this.resetTurnstile()
		})
	}

	mounted() {
		this.code = this.$route.params.code || ''
		this.setFocus()
		this.initClouFlare()
	}
	beforeDestroy() {
		if (this.refreshInterval) clearInterval(this.refreshInterval)
	}

	previous() {
		this.$router.push({name: 'login'})
	}

	private setFocus() {
		let last_name = this.$refs['last-name'] as any
		if (last_name === undefined) return

		last_name.focus()
	}

	private initClouFlare() {
		if (!document.querySelector('script[src="https://challenges.cloudflare.com/turnstile/v0/api.js"]')) {
			const script = document.createElement("script");
			script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js";
			script.async = true;
			script.defer = true;
			document.head.appendChild(script);
		} else {
			this.renderTurnstile()
		}

		(window as any).onTurnstileSuccess = (token) => {
			this.turnstile_token = token;
		};

		(window as any).refreshTurnstile = () => {
			const el = this.$refs.turnstile as HTMLElement;
			if (el && (window as any).turnstile) {
				(window as any).turnstile.reset(el);
			}
		};

		if (this.refreshInterval) clearInterval(this.refreshInterval)

		this.refreshInterval = setInterval(() => {
			(window as any).refreshTurnstile();
		}, 2 * 60 * 1000);
	}

	private resetTurnstile(){
		const el = this.$refs.turnstile as HTMLElement;
		if (el && (window as any).turnstile) {
			(window as any).turnstile.reset(el);
			this.turnstile_token = null;
		}
	}

	private renderTurnstile() {
		const el = this.$refs.turnstile as HTMLElement;
		if (el && (window as any).turnstile && el.children.length === 0) {
				(window as any).turnstile.render(el, {
					sitekey: el.dataset.sitekey,
					callback: "onTurnstileSuccess"
				});
		}
	}
}
